import axios from 'axios'

export const getInvalidBirthdatesConfigurations = async () => {
  const res = (await axios.get(`/invalid-birthdates`)).data
  return res;
}